export const isTicketReservedByGuestComponent = (type?: string) => {
  return type?.includes("GUEST");
};
